import { Button, Typography } from "@mui/material";
// import DialogModal from "components/Dialog/DialogModal";
// import asset from "json/assets";
import React, { useState } from "react";
import styles from "styles/component/RightList.module.scss";
import stylesPopOver from "styles/component/PopOver.module.scss";
import ListTableContent from "components/ListTableContent/ListTableContent";
import PopperComponent from "components/PopperComponent/PopperComponent";
import { useDispatch } from "react-redux";
import {
  selectZone,
  setAddedShapeStatus,
  setEditableArea,
  setSelectedGroup,
} from "redux/MapSlice";
import { useSelectedGroup } from "hooks/MapDetails";
import eventEmitter from "services/event.emitter";
import events from "json/events";

export default function OptionList(props) {
  const {
    index,
    icon,
    // isIcon,
    title,
    // isData,
    optionListStyleTwo,
    onClickEvent = () => {},
    data,
    cancelEdit = () => {},
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const selectedGroup = useSelectedGroup();
  
  const handleClick = (e) => {
    onClickEvent();
    // if (title !== "Scale") { // if scale draw is acive we don't need all the rest
      setAnchorEl(e.currentTarget);
      dispatch(setSelectedGroup(title));
      // turning off opened modal when switching between zones, else it glitches.
      dispatch(setEditableArea(""));
      eventEmitter.emit(events.addMarkerToggle, { visible: false });
      eventEmitter.emit(events.disableDraw); // reseting drawControl
    // }

  };

  const handleClose = () => {
    setAnchorEl(null);
    dispatch(selectZone({})); // removing selected zone details on leaving map view
    dispatch(setSelectedGroup(""));
    dispatch(setEditableArea(""));


    eventEmitter.emit(events.disableDraw);

    // turning off opened modal when closing popup, else it glitches.
    eventEmitter.emit(events.addMarkerToggle, { visible: false });
  };

  const openAnchor = selectedGroup === title && Boolean(anchorEl);
  const isData = data ? true : false;

  return (
    <>
      <>
        <Button
          onClick={(e) => {
            handleClick(e);
          }}
          aria-describedby={index}
          // className={isData && openAnchor && `${styles.active_btn}`}
          className={`${(isData && openAnchor) ? `${styles.active_btn}`: ''}`}
        >
          <span className={styles.icon}>
            <img src={icon} alt="" />
          </span>
        </Button>

        {isData && (
          <PopperComponent
            onClose={() => {
              handleClose();
            }}
            handleOnClose={() => {
              handleClose();
            }}
            open={openAnchor}
            id={index}
            anchorOpen={anchorEl}
            title={title}
          >
 
            <div className={stylesPopOver.list_icon_table}>
              <ListTableContent
                // isTableStylesTwo={optionListStyleTwo}
                contentData={data}
                cancelEdit={cancelEdit}
              />
            </div>
            {/* )} */}
          </PopperComponent>
        )}
 
      </>
    </>
  );
}
